"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrayFields = void 0;
exports["default"] = FieldsArray;
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.date.to-string.js");
require("core-js/modules/es.array.concat.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _components = require("./components");
var _reactFinalForm = require("react-final-form");
var _react = _interopRequireDefault(require("react"));
var _validations = require("./validations");
var _propTypes = require("prop-types");
var _lodash = _interopRequireDefault(require("lodash"));
var _fieldsLegacy = require("./fieldsLegacy");
var _utils = require("./utils");
var _excluded = ["components", "interface", "inputs", "label", "smallLabel", "description", "options", "question_description", "title", "labelStyle", "inputStyle", "config", "validations", "fieldSpacing", "normalize", "format", "parse", "collapseable", "nowDate"];
function FieldsArray(props) {
  var components = props.components,
    intf = props["interface"],
    _props$inputs = props.inputs,
    inputs = _props$inputs === void 0 ? [] : _props$inputs,
    label = props.label,
    smallLabel = props.smallLabel,
    description = props.description,
    options = props.options,
    question_description = props.question_description,
    title = props.title,
    labelStyle = props.labelStyle,
    inputStyle = props.inputStyle,
    _props$config = props.config,
    config = _props$config === void 0 ? {} : _props$config,
    validations = props.validations,
    fieldSpacing = props.fieldSpacing,
    normalize = props.normalize,
    format = props.format,
    parse = props.parse,
    collapseable = props.collapseable,
    _props$nowDate = props.nowDate,
    nowDate = _props$nowDate === void 0 ? new Date() : _props$nowDate,
    restProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  config.disabled = props.disabled;
  var _generateCommonPassed = (0, _fieldsLegacy.generateCommonPassedProps)(props),
    validate = _generateCommonPassed.validate,
    wrapperContent = _generateCommonPassed.wrapperContent,
    fieldName = _generateCommonPassed.fieldName;
  if (props.required) {
    if (validate) {
      validate = (0, _utils.composeValidators)(validate, _validations.noEmptyArray);
    } else {
      validate = _validations.noEmptyArray;
    }
  }
  switch (intf) {
    case "array":
      return /*#__PURE__*/_react["default"].createElement(_components.FieldWrapper, wrapperContent, /*#__PURE__*/_react["default"].createElement(_reactFinalForm.FieldArray, (0, _extends2["default"])({}, restProps, {
        components: components,
        validate: validate,
        name: fieldName,
        component: _components.RenderArray,
        nowDate: nowDate,
        config: restProps
      })));
    case "flatarray":
      return /*#__PURE__*/_react["default"].createElement(_components.FieldWrapper, wrapperContent, /*#__PURE__*/_react["default"].createElement(_reactFinalForm.FieldArray, (0, _extends2["default"])({}, props, {
        components: components,
        validate: validate,
        name: fieldName,
        inputStyle: inputStyle,
        labelStyle: labelStyle,
        label: label,
        component: _components.RenderFlatArray,
        nowDate: nowDate,
        config: restProps
      })));
    default:
      console.warn("Field type ".concat(intf, " \"").concat(label, "\" is not available"));
      return null;
  }
}
FieldsArray.defaultProps = {
  disabled: false
};
FieldsArray.propTypes = {
  "interface": (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, _propTypes.element]).isRequired,
  nowDate: _propTypes.object
};
var ArrayFields = exports.ArrayFields = ['array', 'flatarray'];